import React from "react";
import { Chip, Typography, LinearProgress } from "@mui/material";
import Page from "./Page";
import { db } from "../sql";
import { DataGrid } from "@mui/x-data-grid";
import { useLiveQuery } from "dexie-react-hooks";
import { gql, useQuery } from "@apollo/client";
import { format } from "date-fns";

export default function StoragePage() {
  const { data, loading, error } = useQuery(GET_MY_AUTH);
  return (
    <Page title="Scanning Records">
      <Typography variant="h4" gutterBottom>
        Scanning Records
      </Typography>
      {loading ? (
        <LinearProgress />
      ) : !!error ? (
        <Typography>{JSON.stringify(error, null, 2)}</Typography>
      ) : data?.eventId ? (
        <ScannedList eventId={data.eventId} />
      ) : (
        ""
      )}
    </Page>
  );
}

function ScannedList({ eventId }) {
  const pendingCount = useLiveQuery(() =>
    db.visitors
      .where("eventId")
      .equals(eventId)
      .filter((p) => p.uploaded === 0)
      .count()
  );
  const uploadsCount = useLiveQuery(() =>
    db.visitors
      .where("eventId")
      .equals(eventId)
      .filter((p) => p.uploaded > 0)
      .count()
  );

  return (
    <DataGrid
      sx={{ height: 550 }}
      columns={[
        { field: "id", headerName: "#" },
        { field: "item", width: 300 },
        { field: "count" },
      ]}
      rows={[
        { id: 1, item: "Uploads Pending", count: pendingCount },
        { id: 2, item: "Uploads Done", count: uploadsCount },
      ]}
    />
  );
}

const GET_MY_AUTH = gql`
  query {
    eventId
    standId
  }
`;
